import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import Header from '../../modules/Header/Header'
import Footer from '../../modules/Footer/Footer'

const Layout = ({ children }) => (
  <main>
    <Header />
    {children}
    <Footer />
  </main>
)

Layout.propTypes = {
  children: PropTypes.node
}

const mapStateToProps = (state) => ({

})

export default withRouter(connect(mapStateToProps)(Layout))



// WEBPACK FOOTER //
// ./src/containers/Layout/Layout.jsx